import _ from "lodash";
import { listOldAssets, listOneQueryOfAssets } from "services/apiMiddleware";
import { addOrUpdateArrayItem } from "services/utils";
import { t } from "../../i18n";
import { ORIGINAL_ASSETS_FILTER } from "constants/graphqlFilters";

const oldAssets = {
  state: {
    isLoading: false,
    isLazyLoading: false,
    error: null,
    items: [],
    allItemsLoaded: false,
  },
  reducers: {
    reset: (state) => {
      return {
        ...state,
        isLoading: false,
        isLazyLoading: false,
        error: null,
        items: [],
        allItemsLoaded: false,
      };
    },
    resetModal: (state) => {
      return {
        ...state,
        isLoading: false,
        isLazyLoading: false,
        error: null,
        items: [],
        allItemsLoaded: false,
      };
    },
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    startProcessedPolling: (state) => {
      return {
        ...state,
        isPollingProcessedItems: true,
      };
    },
    loadSuccess: (state, items, processedItems) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
        processedItems,
        allItemsLoaded: true,
      };
    },
    loadOneSuccess: (state, { foundItem, isLoading = false }) => {
      return {
        ...state,
        isLoading,
        error: null,
        items: addOrUpdateArrayItem(state.items, (item) => item.id === foundItem.id, foundItem),
      };
    },
    loadLazyStart: (state) => {
      return {
        ...state,
        isLazyLoading: true,
      };
    },
    loadLazyQueryDone: (state, newItems) => {
      return {
        ...state,
        error: null,
        items: _.concat(state.items, newItems),
      };
    },
    loadLazySuccess: (state) => {
      return {
        ...state,
        error: null,
        isLazyLoading: false,
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
    loadAllFailure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
        allItemsLoaded: false,
      };
    },
    stopLoading: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
  effects: (dispatch) => ({
    /**
     * Loads all assets to state while having isLoading on the whole time
     * @param {object} [payload={}] - Optional payload object
     * @param {boolean} payload.force - Load can be forced regardless if all assets have been loaded before
     */
    async load(payload = {}, state) {
      try {
        // Return if load is not forced and all assets have already been loaded
        if (!payload.force && state.oldAssets.allItemsLoaded) return;
        dispatch.oldAssets.resetModal();
        dispatch.oldAssets.loadStart();
        const { data } = await listOldAssets({ filter: ORIGINAL_ASSETS_FILTER });
        dispatch.oldAssets.loadSuccess(data, state.oldAssets.processedItems);
      } catch (error) {
        console.error(error);
        dispatch.oldAssets.loadAllFailure(t("assets_load_error", { ns: "common" }));
      }
    },
    /**
     * Loads one query of assets to state and the rest in the background. isLoading is on for the first query only, isLazyLoading for the whole time
     * @param {object} [payload={}] - Optional payload object
     * @param {boolean} payload.force - Load can be forced even if all assets have been loaded before
     */
    async loadLazy(payload = {}, state) {
      try {
        // Return if load is not forced and all assets have already been loaded
        if (!payload.force && state.oldAssets.allItemsLoaded) return;
        dispatch.oldAssets.reset();
        dispatch.oldAssets.loadStart();
        dispatch.oldAssets.loadLazyStart();
        const result = await listOneQueryOfAssets({ filter: ORIGINAL_ASSETS_FILTER });
        dispatch.oldAssets.loadSuccess(result.data, []);
        let nextToken = result.nextToken;
        // Load the rest one query at a time as long as the query returns nextToken
        if (nextToken) {
          do {
            const result = await listOneQueryOfAssets({
              nextToken,
              filter: ORIGINAL_ASSETS_FILTER,
            });
            dispatch.oldAssets.loadLazyQueryDone(result.data);
            nextToken = result.nextToken;
          } while (nextToken);
        }
        dispatch.oldAssets.loadLazySuccess();
      } catch (error) {
        console.error(error);
        dispatch.oldAssets.loadAllFailure(t("assets_load_error", { ns: "common" }));
      }
    },
  }),
};

export default oldAssets;
